import { useWindowDimensions } from '../context';

const ResponsiveLayout = ({ renderMobile, renderDesktop }) => {
  const { width } = useWindowDimensions();
  return width > 992 ? renderDesktop() : renderMobile();
};

export default ResponsiveLayout;
